import { User } from 'features/auth/types';
import { isAdminOrSuperAdmin, isOperatorOrHigher } from 'features/auth/helpers';
import { RolesEnum } from 'features/common/types';

/**
 * Quién usa la mesa de cruces.
 *
 * - **Ver** (las dos solapas): operador o superior.
 * - **Cambiar** reglas y plazos: admin o superadmin. Es el mismo criterio que
 *   aplica la API (roles 1 y 10): si alguien más lo intentara, recibiría un 403.
 * - **Cobrar** (crear y cancelar cobros, simular el plan): los roles que la API
 *   deja cobrar, todos menos Visor (3) y Agente Corpo (6).
 *
 * Sin usuario, o con un rol que no se conoce, no ve ni cambia nada.
 */
export interface CardDeskAccess {
	canView: boolean;
	canEdit: boolean;
	canCharge: boolean;
}

/** Los `CHARGE_ROLES` de la API: admin, usuario, vendedor, operador y superadmin. */
const CHARGE_ROLES: readonly number[] = [
	RolesEnum.ADMIN,
	RolesEnum.USER,
	RolesEnum.SELLER,
	RolesEnum.OPERATOR,
	RolesEnum.SUPERADMIN,
];

export function getCardDeskAccess(user: User | null | undefined): CardDeskAccess {
	const current = user ?? null;
	const canView = isOperatorOrHigher(current);
	return {
		canView,
		// Quien cambia también tiene que poder ver: no hay edición sin acceso.
		canEdit: canView && isAdminOrSuperAdmin(current),
		canCharge: canView && current !== null && CHARGE_ROLES.includes(current.role),
	};
}
